import React from 'react';
import { AuthProvider as NewAuthProvider } from '@/contexts/AuthContext';

interface AuthProviderProps {
  children: React.ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  // Only use backend authentication
  return <NewAuthProvider>{children}</NewAuthProvider>;
}

// Re-export useAuth hook
export { useAuth } from '@/hooks/useAuth';